import { Component, OnInit } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { Observable, Subject, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { FormData } from '@fry/lib/forms';
import { NotifyService } from '@fry/lib/utils';
import { BookingItem } from '@fry/booking/lib/booking-items';
import { EasFormGroup } from '@fry/components/common/easform';
import { BookingType, BookingTypesStore } from '@fry/booking/lib';
import { BuilderService } from '@fry/components/common/form-builder/builder.service';

@Component({
    selector: 'eas-booking-item-preview',
    templateUrl: './booking-item-preview.component.html',
    standalone: false
})
export class BookingItemPreviewComponent implements OnInit {

  public bookingItem: BookingItem;
  public bookingItem$: Observable<BookingItem>;
  public bookingOptions: any[];
  public bookingOption: any;

  public previewForm: EasFormGroup;
  public form$ = new Subject<any>();

  public formData$: Observable<FormData>;
  public easFormGroup$: Observable<EasFormGroup>;
  public bookingType$: Observable<BookingType>;
  public optionPicker: UntypedFormControl;

  public rolePicker: UntypedFormControl;
  public roles: string[];
  public state: any;

  error: string;
  model: any;
  debug = false;

  constructor(
    private route: ActivatedRoute,
    private notify: NotifyService,
    private bookingTypes: BookingTypesStore,
    private builder: BuilderService
  ) { }

  ngOnInit() {
    this.bookingItem$ = this.route.data.pipe(
      map(data => {
        this.bookingItem = data.bookingItem;
        this.bookingType$ = this.bookingTypes.get(this.bookingItem.doc.bookingType);
        this.bookingOptions = this.getBookingOptions(this.bookingItem.doc);
        this.optionPicker = new UntypedFormControl();

        this.optionPicker.valueChanges.subscribe(val => {
          this.loadOption(val);
        });
        return data.bookingItem;
      }),
      catchError(error => {
        this.error = error;
        this.notify.error(error);
        return throwError(error);
      }),
    );
  }

  getBookingOptions(session) {
    const options = [
      session,
      ...session.subsessions.reduce((acc, val) => acc = acc.concat(this.getBookingOptions(val)), [])
    ];
    return options;
  }

  loadOption(option) {
    this.rolePicker = null;
    this.model = {data: {}};
    this.bookingOption = option;
    this.loadState();
  }

  loadState() {
    this.state = this.getState(this.bookingOption);
    this.roles = this.getRoles(this.state);
    this.rolePicker = new UntypedFormControl();
    this.form$.next(undefined);
    this.rolePicker.valueChanges.subscribe(role => {
      this.loadForm(role);
    });

  }

  getState(option) {
    const states = option.form.states;

    let state: any;
    if (!this.model.state) {
      state = states.find(itm => itm.initial);
      this.model.state = state.id;
    } else {
      state = states.find(itm => itm.id === this.model.state);
    }
    return state;
  }

  getRoles(state) {
    let roles = [];
    Object.values(state).forEach((group: any) => {
      if (!group.roles) {
        return;
      }

      roles = roles.concat(group.roles.map(role => role.role));
    });
    return Array.from(new Set(roles));
  }

  loadForm(role) {
    const context = {
      state: this.state.id,
      metadata: {},
    };

    this.builder.buildWFForm(this.bookingOption.form,
                             this.model,
                             this.model.data,
                             context,
                             'owner',
                             role).subscribe(res => {
      console.log('New Form', res);
      this.previewForm = res.group;
      this.form$.next({
        group: this.previewForm,
        transitions: res.transitions
      });
    });
  }

  doTransition(trans) {
    this.model.state = trans.destination;
    const curVal = this.previewForm.getValue();
    this.model.data = {...this.model.data, ...curVal};
    this.loadState();
  }

  // getForm(state, role): Observable<EasFormGroup> {
  //   if (!option.form) {
  //     return of(undefined);
  //   }
  //   const states = option.form.states;
  //   const initial = states.find(itm => itm.initial);
  //   this.model = {
  //     state: initial.name,
  //     data: {}
  //   };
  //   return this.builder.buildForm(option.form.group).pipe(
  //     map(group => this.easForm.createForm(group, this.model.data))
  //   );
  // }

  getDefaultOptionTitle() {
    return $localize `Main`;
  }
}
